import { Box, Stack, Divider } from '@mui/material';
import Typography from "@vapor/react-extended/ExtendedTypography";
import { FascicoliListView } from './FascicoliListView';

export const AnagraficaDetailsView = ({ 
    anagrafica, 
    differentFields,
    baseTipoIdentList,
    baseTipoDocList,
    baseProvinciaList,
    baseComuniList,
    allUsers,
    fascicoli // Nuova prop per i fascicoli associati
}) => {
    const getFieldColor = (fieldName) => {
        return differentFields && differentFields.has(fieldName) ? 'error.main' : 'inherit';
    };
    
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
            {/* Colonna Principale - Dati Anagrafici e Identificativi */}
            <Box sx={{ flex: 1 }}>                
                {!anagrafica.isPg ? (
                    <>
                        <Typography variant="body2" sx={{ mb: 1, color: getFieldColor('nome') }}>
                            <strong>Nome:</strong> {anagrafica.nome || 'N/A'}
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 1, color: getFieldColor('cognome') }}>
                            <strong>Cognome:</strong> {anagrafica.cognome || 'N/A'}
                        </Typography>
                    </>
                ) : (
                    <Typography variant="body2" sx={{ mb: 1, color: getFieldColor('denominazione') }}>
                        <strong>Denominazione:</strong> {anagrafica.denominazione || 'N/A'}
                    </Typography>
                )}
                <Typography variant="body2" sx={{ mb: 1, color: getFieldColor('cf') }}>
                    <strong>Codice Fiscale:</strong> {anagrafica.cf || 'N/A'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, color: getFieldColor('pIva') }}>
                    <strong>P.IVA:</strong> {anagrafica.pIva || 'N/A'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, color: getFieldColor('nascitaData') }}>
                    <strong>Data di nascita:</strong> {anagrafica.nascitaData ? new Date(anagrafica.nascitaData).toLocaleDateString() : 'N/A'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, color: getFieldColor('nascitaLuogo') }}>
                    <strong>Luogo di nascita:</strong> {anagrafica.nascitaLuogo || 'N/A'}
                </Typography>
                <Divider sx={{ my: 2 }} />  
                <Stack direction="column" spacing={1}>                     
                    <Typography variant="body2" sx={{ color: getFieldColor('modalitaIdentId') }}>
                        <strong>Modalità Identificazione ID:</strong> {anagrafica.modalitaIdentId ? (baseTipoIdentList.filter(x=> x.id === anagrafica.modalitaIdentId)[0]?.value || anagrafica.modalitaIdentId) : 'N/A'}
                    </Typography>
                    <Typography variant="body2" sx={{ color: getFieldColor('docTipoId') }}>
                        <strong>Tipo Documento ID:</strong> {anagrafica.docTipoId ? (baseTipoDocList.filter(x=> x.id === anagrafica.docTipoId)[0]?.value || anagrafica.docTipoId) : 'N/A'}
                    </Typography>
                    <Typography variant="body2" sx={{ color: getFieldColor('docN') }}>
                        <strong>Numero Documento:</strong> {anagrafica.docN || 'N/A'}
                    </Typography>
                    <Typography variant="body2" sx={{ color: getFieldColor('docRilDa') }}>
                        <strong>Rilasciato da:</strong> {anagrafica.docRilDa || 'N/A'}
                    </Typography>
                    <Stack direction="row" spacing={2}>
                        <Typography variant="body2" sx={{ color: getFieldColor('docRilData') }}>
                            <strong>Data Rilascio:</strong> {anagrafica.docRilData ? new Date(anagrafica.docRilData).toLocaleDateString() : 'N/A'}
                        </Typography>
                        <Typography variant="body2" sx={{ color: getFieldColor('docScad') }}>
                            <strong>Data Scadenza:</strong> {anagrafica.docScad ? new Date(anagrafica.docScad).toLocaleDateString() : 'N/A'}
                        </Typography>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <Typography variant="body2" sx={{ color: getFieldColor('identifiedByUser') }}>
                            <strong>Identificato da:</strong> {anagrafica.identifiedByUser ? (allUsers.filter(user => user.userId === anagrafica.identifiedByUser)[0]?.completeName || anagrafica.identifiedByUser) : 'N/A'}
                        </Typography>
                        <Typography variant="body2" sx={{ color: getFieldColor('identifiedOn') }}>
                            <strong>Data Identificazione:</strong> {anagrafica.identifiedOn ? new Date(anagrafica.identifiedOn).toLocaleDateString() : 'N/A'}
                        </Typography>
                    </Stack>                        
                </Stack>                              
            </Box>

            <Divider orientation="vertical" flexItem />

            {/* Colonna Laterale - Indirizzo e Info Aggiuntive */}
            <Box sx={{ flex: 1 }}>
                <Typography variant="body2" sx={{ mb: 1, color: getFieldColor('addrIndirizzo') || getFieldColor('addrN') }}>
                    <strong>Indirizzo:</strong> {anagrafica.addrIndirizzo && anagrafica.addrN ? `${anagrafica.addrIndirizzo}, ${anagrafica.addrN}` : 'N/A'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, color: getFieldColor('addrComuneId') || getFieldColor('addrProvinciaId') || getFieldColor('addrCap') }}>
                    <strong>Città:</strong> {anagrafica.addrComuneId || anagrafica.addrProvinciaId || anagrafica.addrCap 
                        ? `${baseComuniList.filter(x => x.id === anagrafica.addrComuneId)[0]?.nome || 'N/A'} (${baseProvinciaList.filter(x=> x.id === anagrafica.addrProvinciaId)[0]?.sigla || anagrafica.addrProvinciaId || 'N/A'}) - ${anagrafica.addrCap || 'N/A'}`
                        : 'N/A'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, color: getFieldColor('professione') }}>
                    <strong>Professione:</strong> {anagrafica.professione || 'N/A'}
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body2" sx={{ mb: 1, color: getFieldColor('versionN') }}>
                    <strong>Versione:</strong> {anagrafica.versionN || 'N/A'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Creato il:</strong> {anagrafica.createdOn ? new Date(anagrafica.createdOn).toLocaleString() : 'N/A'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, color: getFieldColor('modifiedOn') }}>
                    <strong>Modificato il:</strong> {anagrafica.modifiedOn ? new Date(anagrafica.modifiedOn).toLocaleString() : 'N/A'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, color: getFieldColor('isPep') }}>
                    <strong>PEP:</strong> {anagrafica.isPep !== undefined ? (anagrafica.isPep ? 'Sì' : 'No') : 'N/A'}
                </Typography>                    
            </Box>

            <Divider orientation="vertical" flexItem />

            {/* Colonna Fascicoli - Lista fascicoli associati */}
            <Box sx={{ flex: 1, minWidth: '250px', maxHeight: '350px', overflow: 'hidden' }}>
                <FascicoliListView fascicoli={fascicoli} />
            </Box>
        </Box>
    );
};
